import { DeceasedClient } from '@frontend/deceased/api';
import { IDeceased } from '@frontend/deceased/types';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { useAppDispatch } from '../../redux/store';

export const useDeceasedUpdate = () => {
    const navigate = useNavigate();
    const { accountId, deceasedId } = useParams();
    const dispatch = useAppDispatch();
    const [deceased, setDeceased] = useState<IDeceased | null>(null);

    useEffect(() => {
        if (!accountId || !deceasedId) return;
        DeceasedClient.fetchDeceased(accountId, deceasedId).then((result) => {
            setDeceased(result);
        });
    }, [accountId, deceasedId]);

    const onCancel = () => {
        navigate(-1);
    };

    const onSubmitSuccess = (result: IDeceased) => {
        navigate(`/accounts/${result.account_id}/deceased/${result.id}/detail`);
    };

    return {
        deceased,
        onCancel,
        onSubmitSuccess,
        dispatch
    };
};
